import React from 'react';

import RebecaIcon from '../../../assets/contactUs/rebeca_icon.svg';
import WhatsAppIcon from '../../../assets/contactUs/whatsapp_purple_icon.svg';
import EmailIcon from '../../../assets/contactUs/email_callcenter_icon.svg';
import CallCenterIcon from '../../../assets/contactUs/callcenter_icon.svg';
import {
  callCenterContactUs,
  emailContactUs,
  whatsAppContactUs,
  whatsAppContactUsUrl,
} from '../../../constants';

const contactUsList = [
  {
    title: 'Conoce a Rebeca',
    subtitle: 'Nuestra asistente virtual está disponible las 24 horas del día.',
    src: RebecaIcon,
  },
  {
    title: (
      <div>
        WhatsApp:{' '}
        <a href={whatsAppContactUsUrl} target="_blank" rel="noreferrer">
          {whatsAppContactUs}
        </a>
      </div>
    ),
    subtitle: 'Conversemos, estamos en línea.',
    src: WhatsAppIcon,
  },
  {
    title: (
      <div>
        Call Center:{' '}
        <a href={`tel:${callCenterContactUs}`}>{callCenterContactUs}</a>
      </div>
    ),
    subtitle: 'Llámanos de lunes a domingo de 9am a 9pm.',
    src: CallCenterIcon,
  },
  {
    title: (
      <div>
        Correo: <a href={`mailto:${emailContactUs}`}>{emailContactUs}</a>
      </div>
    ),
    subtitle: 'Escríbenos, estamos atentos a tus consultas.',
    src: EmailIcon,
  },
];

export default contactUsList;
